import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RepositoryService } from "../../shared/services/repository.service";
import { Frequency, MitigatingAction } from "../../_interfaces/MitigatingAction.model";
import { MitigatingActionAudit } from "../../_interfaces/MitigatingActionAudit.model";
import { formatDate } from '@angular/common';
import { MitigatingActionReview } from "../../_interfaces/MitigatingActionReview.model";
import { RiskUser } from './../../_interfaces/RiskUser.model';
import { getControlEffectivenessLabel } from '../../_interfaces/ControlEffectivenessEnum';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-mitigating-action',
  templateUrl: './mitigating-action.component.html',
  styleUrls: ['./mitigating-action.component.css']
})
export class MitigatingActionComponent implements OnInit {
  mitigationForm: FormGroup;
  submitted = false;
  mitigatingAction: MitigatingAction;
  mitigationReviews: MitigatingActionReview[];
  mitigationAudits: MitigatingActionAudit[];
  // cost_Based: boolean;
  public user: RiskUser;
  mitigationId: number;

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private alertService: AlertService
  ) {

    //this.cost_Based = true;
  }

  get Frequency(): typeof Frequency{
    return Frequency;
  }

  ngOnInit() {

    this.repository.SetupPeople(); 

    this.getRiskMitigationDetails();



    this.mitigationForm = this.formBuilder.group({
      //eventId: ['', Validators.required],
      title: ['', Validators.required],
      description: ['', Validators.required],
      controlType: ['', Validators.required],
      frequency: ['', Validators.required],
      automatic: [false, Validators.required],
      controlWeighting: [''],
      controlEffectiveness: [''],
      keyStatus: [false, Validators.required],
      reviewAndUpdateDate: ['', Validators.required],
      costBased: [''],
      costReduction: [''],
    });

    this.getMitigationReviewList();

    this.user = this.repository.GetMyUser();
  }

  getRiskMitigationDetails() {
    this.mitigationId = this.activeRoute.snapshot.params['id'];
    const apiUrl: string = `MitigatingActions/${this.mitigationId}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.mitigatingAction = res as MitigatingAction;

        this.f.title.setValue(this.mitigatingAction.title);
        this.f.description.setValue(this.mitigatingAction.description);
        this.f.controlType.setValue(this.mitigatingAction.controlType);
        this.f.frequency.setValue(this.mitigatingAction.frequency);
        this.f.automatic.setValue(this.mitigatingAction.automatic);
        this.f.controlWeighting.setValue(this.mitigatingAction.controlWeighting);
        this.f.controlEffectiveness.setValue(this.mitigatingAction.controlEffectiveness);
        this.f.keyStatus.setValue(this.mitigatingAction.keyStatus);
        const review = formatDate(this.mitigatingAction.reviewAndUpdateDate, 'yyyy-MM-dd', 'en');
        this.f.reviewAndUpdateDate.setValue(review);
        this.f.costReduction.setValue(this.mitigatingAction.costReduction);
        this.f.costBased.setValue(this.mitigatingAction.costBased);
        if (this.mitigatingAction.costBased) {
          this.f.controlWeighting.disable();
          this.f.controlEffectiveness.disable();
        } else {
          this.f.costReduction.disable();
        }
        
      });
  }

  get f() { return this.mitigationForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.mitigationForm.invalid) {
      return; // stop here if form is invalid
    }
    this.updateMitigationFromForm();

    // Save updated Mitigating Action here
    let apiAddress: string = `MitigatingActions`;

    this.repository.update(apiAddress, this.mitigatingAction)
      .subscribe(res => {
          this.alertService.success('Successfully updated mitigation.');
        }, error => {
          this.alertService.error('Failed to update mitigation.');
          alert('Error:!' + error.message + '\n\n');
        }
      );
  }
  updateMitigationFromForm() {
    // Cast the numeric form values to numbers
    //if (this.f.controlWeighting.value) {
      this.mitigatingAction.controlWeighting = + 100 // RDP-69  // this.f.controlWeighting.value; // Note - the + casts the value to a number. Without the + web api doesn't recognise the object 
    //}
    if (this.f.controlEffectiveness.value) {
      this.mitigatingAction.controlEffectiveness = + this.f.controlEffectiveness.value;
    }
    if (this.f.costReduction.value) {
      this.mitigatingAction.costReduction = + this.f.costReduction.value;
    }
    //frequency
    if (this.f.frequency.value) {
      this.mitigatingAction.frequency = + this.f.frequency.value;
    }
    if (this.f.controlType.value) {
      this.mitigatingAction.controlType = + this.f.controlType.value;
    }

    // non-numeric fields
    // this.mitigatingAction.keyStatus = this.f.keyStatus.value; // 
    if (this.f.keyStatus.value === "true" || this.f.keyStatus.value === true ) {
      this.mitigatingAction.keyStatus = true;
    } else {
      this.mitigatingAction.keyStatus = false;
    }
    this.mitigatingAction.reviewAndUpdateDate = this.f.reviewAndUpdateDate.value;
    // this.mitigatingAction.automatic = this.f.automatic.value; // 
    if (this.f.automatic.value === "true" || this.f.automatic.value === true) {
      this.mitigatingAction.automatic = true;
    } else {
      this.mitigatingAction.automatic = false;
    }

    this.mitigatingAction.description = this.f.description.value;
    this.mitigatingAction.title = this.f.title.value;

  }

  onCancelForm() {
    this.submitted = false;
    const riskDetailUrl: string = `/myrisks/details/${this.mitigatingAction.riskId}`; // ToDo - test this
    this.router.navigate([riskDetailUrl]);
  }

  // mitigation-review
  getMitigationReview(id: number) {
    this.router.navigate(['review', id], { relativeTo: this.activeRoute });
  }

  createMitigationReview() {
    this.router.navigate(['review'], { relativeTo: this.activeRoute });
  }

  getMitigationReviewList() {
    // service call to get the list of reviews for this Mitigation/Control
    const id: string = this.activeRoute.snapshot.params['id'];
    //let id: string = this.mitigatingAction.id.toString();
    const apiUrl: string = `MitigatingActions/${id}/Reviews`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.mitigationReviews = res as MitigatingActionReview[];
      });
  }

  getMitigationAuditList() {
    // service call to get the list of audit records for this Mitigation/Control
    const id: string = this.activeRoute.snapshot.params['id'];
    //let id: string = this.mitigatingAction.id.toString();
    const apiUrl: string = `MitigationsAudit/ByMitigatingActionId/${id}`
    //let apiUrl: string = `MitigationsAudit`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.mitigationAudits = res as MitigatingActionAudit[];
      });
  }

 getControlEffectivenessLabel(controlEffectivenessValue: number | string): string {
    return getControlEffectivenessLabel(controlEffectivenessValue);
  }
}


